import { useQuery } from "@tanstack/react-query"
import { isAxiosError } from "axios"

import { getOrdersByPartOfId } from "@/api/ordersApi"
import { IOrderResponse } from "@/shared/types"
import { showToast } from "@/shared/utils"

const sortOrdersOldestFirst = (orders: IOrderResponse[]) =>
  [...orders].sort(
    (a, b) => new Date(a.createdInApollo).getTime() - new Date(b.createdInApollo).getTime(),
  )

export const useConnectedOrders = (orgId: string, originalOrderId: string) => {
  const isEnabled = !!orgId && !!originalOrderId

  return useQuery(
    ["connectedOrders", orgId, originalOrderId],
    async () => sortOrdersOldestFirst(await getOrdersByPartOfId(orgId, originalOrderId)),
    {
      staleTime: 30 * 1000,
      cacheTime: isEnabled ? 30 * 1000 : 0,
      keepPreviousData: true,
      enabled: isEnabled,
      onError: (error) => {
        if (isAxiosError(error)) {
          showToast({ type: "error", text: error.response?.data.errorMessage || error.message })
        }
      },
    },
  )
}
